export interface PublicStatsDto {
  activeSommeliers: number;
  wineries: number;
  countries: number;
  pickupPoints: number;
}

export interface LabelsByCountryItemDto {
  country?: string;
  count: number;
}

export interface PublicPickupPointDto {
  name?: string;
  address?: string;
  province?: string;
  city?: string;
  lat?: number;
  lng?: number;
}
